import { JsonSchema7Builder } from "@/v2/components/json-schema-7-builder";
import { JSONSchema7, JSONSchema7Definition } from "json-schema";
import { useCallback } from "react";

const defaultSchema: JSONSchema7 = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {},
};

interface BodyProps {
  schema?: JSONSchema7;
  onValueChange: (schema: JSONSchema7) => void;
}

export function Body({ schema = defaultSchema, onValueChange }: BodyProps) {
  const handleSchemaChange = useCallback(
    (newSchema: JSONSchema7Definition) => {
      // Ensure we only pass valid JSONSchema7 objects, not boolean values
      if (typeof newSchema === "object" && newSchema !== null) {
        onValueChange(newSchema as JSONSchema7);
      }
    },
    [onValueChange]
  );

  return (
    <div className="h-full">
      <JsonSchema7Builder
        title="Body"
        schema={schema}
        onChange={handleSchemaChange}
        className="h-full"
      />
    </div>
  );
}
